module.exports = __webpack_public_path__ + "static/media/28_offline.3a1aeafa.png";